// ...existing imports...
import React, { useState } from 'react';
import MetricItem from './MetricItem';
import GoogleCampaigns from './GoogleCampaigns';
var GoogleMetrics = function (_a) {
    var _b, _c, _d;
    var data = _a.data;
    var _e = useState(false), modalOpen = _e[0], setModalOpen = _e[1];
    if (!data)
        return (React.createElement("div", { className: "px-4 py-3 text-gray-500 italic text-center" }, "Sem campanha ativa"));
    var daysRemaining = "-";
    var daysLabel = "dias";
    if (typeof data.available_balance === "number" &&
        typeof data.daily_budget === "number" &&
        data.daily_budget > 0) {
        var calcDays = Math.floor(data.available_balance / data.daily_budget);
        daysRemaining = calcDays;
        daysLabel = calcDays <= 1 ? "dia" : "dias";
    }
    return (React.createElement("div", { className: "p-0.5 2xl:p-1 2xl:p-2 grid grid-cols-4 gap-0.5 2xl:gap-2 w-full" },
        React.createElement(MetricItem, { label: "Impress\u00F5es", value: "".concat(data.impressions), account_stopped: data === null || data === void 0 ? void 0 : data.account_stopped, color: "#38bdf8", size: "large" }),
        React.createElement(MetricItem, { label: "Gasto", value: typeof data.cost === "number"
                ? "R$ ".concat(Number((_b = data.cost) !== null && _b !== void 0 ? _b : 0).toFixed(2).replace('.', ','))
                : "-", color: "#22c55e", size: "large" }),
        React.createElement(MetricItem, { label: "Saldo", value: typeof data.available_balance === "number"
                ? (typeof daysRemaining === "number" &&
                    daysRemaining >= 0 &&
                    data.campaigns &&
                    data.campaigns.length > 0
                    ? "R$ ".concat(Number((_c = data.available_balance) !== null && _c !== void 0 ? _c : 0).toFixed(2).replace('.', ','), " | ").concat(daysRemaining, " ").concat(daysLabel)
                    : "R$ ".concat(Number((_d = data.available_balance) !== null && _d !== void 0 ? _d : 0).toFixed(2).replace('.', ',')))
                : data.available_balance === "Conta Pós Paga"
                    ? "Conta Pós Paga"
                    : "-", color: "#facc15", link: "https://ads.google.com/aw/billing/summary?customer=".concat(data.G_CustomerID), size: "large", daysRemaining: typeof daysRemaining === "number" ? daysRemaining : undefined, classAdd: "col-span-2" }),
        React.createElement("div", { className: "col-span-4 grid grid-cols-2 gap-2" },
            data.campaigns && data.campaigns.length > 0 ? (React.createElement("div", { className: "col-span-4 grid grid-cols" },
                React.createElement("div", { className: "text-xs 2xl:text-lg border border-gray-700 rounded-lg bg-gray-800/60 text-gray-400 shadow-md flex items-center opacity-70 cursor-pointer hover:opacity-100 hover:border-orange-400 transition-all px-1 2xl:px-3 py-4", title: "Clique para ver detalhes", onClick: function () { return setModalOpen(true); } },
                    "Acessar Campanhas Google ADS",
                    React.createElement("span", { className: "inline-flex items-center justify-center w-5 h-5 ml-2 rounded-full bg-green-500 text-white text-[11px] font-bold" }, data.campaigns.length)))) : (React.createElement("div", { className: "col-span-4 text-center text-gray-500 italic" }, "Nenhuma Campanha Ativa.")),
            React.createElement(GoogleCampaigns, { data: data.campaigns, open: modalOpen, onClose: function () { return setModalOpen(false); }, title: "Campanhas do Google ADS Ativas", maxWidth: "max-w-[98vw]", onEditCampaign: function (item, type) {
                    var _a;
                    var customerId = (_a = data.G_CustomerID) === null || _a === void 0 ? void 0 : _a.replace(/-/g, '');
                    var url = '';
                    if (type === 'campaign') {
                        url = "https://ads.google.com/aw/campaigns?campaignId=".concat(item.campaign_id, "&ocid=").concat(customerId);
                    }
                    else if (type === 'adset') {
                        url = "https://ads.google.com/aw/adgroups?adGroupId=".concat(item.ad_group_id, "&ocid=").concat(customerId);
                    }
                    else {
                        url = "https://ads.google.com/aw/ads?adId=".concat(item.ad_id, "&ocid=").concat(customerId);
                    }
                    window.open(url, '_blank');
                } }))));
};
export default GoogleMetrics;
